




























































import { EVisitorFacilityStatus } from "@/shared/models/eVisitorFacilityStatus";
import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import { Action, Getter } from "vuex-class";
import { EVisitorReportTypeEnum } from "../EVisitorReportDialog.vue";
import NumericInputImproved from "@/components/numbers/NumericInputImproved.vue";
import LoadingOverlay from "@/components/misc/LoadingOverlay.vue";

export type ETurizemReportItemModel = {
  facilityId: number;
  facility: string;
  accountName: string;
  numberOfUnits: number;
  numberOfBeds: number;
  numberOfExtraBeds: number;
  eVisitorFacilityStatusId: number;
  numberOfStays: number;
  numberOfDaysOpen: number;
};

@Component({
  components: {
    NumericInputImproved,
    LoadingOverlay,
  },
})
export default class ETurizemReportForm extends Vue {
  @Prop({ default: null }) dateFrom?: Date;
  @Prop({ default: null }) dateTo?: Date;
  @Prop({ default: () => EVisitorReportTypeEnum.Monthly })
  reportType?: EVisitorReportTypeEnum;

  submit() {
    if (this.dateFrom && this.dateTo && this.reportType) {
      const request = {
        dateFrom: this.dateFrom,
        dateTo: this.dateTo,
        itemsJson: JSON.stringify(this.formData),
      };

      this.$emit(
        "submit",
        request,
        undefined,
        "ETurizem.MonthlyReport.Export.Success"
      );
    }
  }

  get refreshFactors() {
    return {
      dateFrom: this.dateFrom,
      dateTo: this.dateTo,
    };
  }

  loading = false;
  formData: ETurizemReportItemModel[] = [];

  @Watch("refreshFactors", { immediate: true, deep: true })
  refresh() {
    if (this.refreshFactors.dateFrom && this.refreshFactors.dateTo) {
      this.loading = true;
      Vue.axios
        .get<ETurizemReportItemModel[]>("evisitor/GetETurizemReportPrefil", {
          params: {
            dateFrom: this.refreshFactors.dateFrom,
            dateTo: this.refreshFactors.dateTo,
          },
        })
        .then((res) => {
          this.formData = res.data;
        })
        .finally(() => {
          this.loading = false;
        });
    }
  }

  @Getter("codebooks/eVisitorFacilityStatuses")
  eVisitorFacilityStatuses?: EVisitorFacilityStatus[];
  @Action("codebooks/refreshEVisitorFacilityStatuses")
  refreshEVisitorFacilityStatuses?: () => Promise<void>;

  async created() {
    const promises = [];

    if (
      (!this.eVisitorFacilityStatuses ||
        this.eVisitorFacilityStatuses.length == 0) &&
      this.refreshEVisitorFacilityStatuses
    ) {
      promises.push(this.refreshEVisitorFacilityStatuses());
    }

    await Promise.all(promises);
  }
}
